"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportChannelMap = exports.EVENT_VERSION = exports.EVENT_NAME = void 0;
exports.ftReport = ftReport;
const fego_render_1 = require("@futuweb/fego-render");
exports.EVENT_NAME = {
    CLICK_SHARE_BTN: 'ClickShareBtn',
    SHARE: 'Share',
    SHARE_FEGO: 'ShareFego'
};
exports.EVENT_VERSION = {
    CLICK_SHARE_BTN: 1,
    SHARE: 10,
    SHARE_FEGO: 1
};
exports.reportChannelMap = {
    niuyou: 'chat',
    chatRoom: 'chat',
    nnq: 'feed',
    wxFriend: 'wechat_friend',
    wxTimeline: 'wechat_moments',
    qq: 'qq',
    weibo: 'sina_weibo',
    facebook: 'facebook',
    twitter: 'x',
    whatsapp: 'whats_app',
    sms: 'sms',
    email: 'email',
    copy: 'copy',
    system: 'more',
    messenger: 'messenger',
    instagram: 'instagram',
    dingtalk: 'dingding',
    line: 'line',
    telegram: 'telegram',
    xiaohongshu: 'xiaohongshu',
    reddit: 'reddit'
};
function ftReport(eventName, reportObj = {}, eventVersion = exports.EVENT_VERSION.CLICK_SHARE_BTN) {
    const ftReportIns = (0, fego_render_1.getFtReport)();
    // 如果是fego上报分享成功事件，则需要添加page_id
    if (eventName === exports.EVENT_NAME.SHARE_FEGO) {
        const pageId = ftReportIns.getPageId() || '';
        const sessionInfo = ftReportIns.getSessionInfo() || {};
        Object.assign(reportObj, {
            page_id: pageId,
            session_info: JSON.stringify(sessionInfo),
            channel_name: exports.reportChannelMap[reportObj.channel_name] || ''
        });
    }
    ftReportIns.sdReport({
        eventName,
        eventVersion,
        payload: reportObj
    });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVwb3J0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsicmVwb3J0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQTJDQSw0QkFpQkM7QUE1REQsc0RBQW1EO0FBRXRDLFFBQUEsVUFBVSxHQUFHO0lBQ3RCLGVBQWUsRUFBRSxlQUFlO0lBQ2hDLEtBQUssRUFBRSxPQUFPO0lBQ2QsVUFBVSxFQUFFLFdBQVc7Q0FDMUIsQ0FBQztBQUVXLFFBQUEsYUFBYSxHQUFHO0lBQ3pCLGVBQWUsRUFBRSxDQUFDO0lBQ2xCLEtBQUssRUFBRSxFQUFFO0lBQ1QsVUFBVSxFQUFFLENBQUM7Q0FDaEIsQ0FBQztBQUVXLFFBQUEsZ0JBQWdCLEdBQUc7SUFDNUIsTUFBTSxFQUFFLE1BQU07SUFDZCxRQUFRLEVBQUUsTUFBTTtJQUNoQixHQUFHLEVBQUUsTUFBTTtJQUNYLFFBQVEsRUFBRSxlQUFlO0lBQ3pCLFVBQVUsRUFBRSxnQkFBZ0I7SUFDNUIsRUFBRSxFQUFFLElBQUk7SUFDUixLQUFLLEVBQUUsWUFBWTtJQUNuQixRQUFRLEVBQUUsVUFBVTtJQUNwQixPQUFPLEVBQUUsR0FBRztJQUNaLFFBQVEsRUFBRSxXQUFXO0lBQ3JCLEdBQUcsRUFBRSxLQUFLO0lBQ1YsS0FBSyxFQUFFLE9BQU87SUFDZCxJQUFJLEVBQUUsTUFBTTtJQUNaLE1BQU0sRUFBRSxNQUFNO0lBQ2QsU0FBUyxFQUFFLFdBQVc7SUFDdEIsU0FBUyxFQUFFLFdBQVc7SUFDdEIsUUFBUSxFQUFFLFVBQVU7SUFDcEIsSUFBSSxFQUFFLE1BQU07SUFDWixRQUFRLEVBQUUsVUFBVTtJQUNwQixXQUFXLEVBQUUsYUFBYTtJQUMxQixNQUFNLEVBQUUsUUFBUTtDQUNuQixDQUFDO0FBT0YsU0FBZ0IsUUFBUSxDQUFDLFNBQVMsRUFBRSxTQUFTLEdBQUcsRUFBRSxFQUFFLFlBQVksR0FBRyxxQkFBYSxDQUFDLGVBQWU7SUFDNUYsTUFBTSxXQUFXLEdBQUcsSUFBQSx5QkFBVyxHQUFFLENBQUM7SUFDbEMsK0JBQStCO0lBQy9CLElBQUksU0FBUyxLQUFLLGtCQUFVLENBQUMsVUFBVSxFQUFFLENBQUM7UUFDdEMsTUFBTSxNQUFNLEdBQUcsV0FBVyxDQUFDLFNBQVMsRUFBRSxJQUFJLEVBQUUsQ0FBQztRQUM3QyxNQUFNLFdBQVcsR0FBRyxXQUFXLENBQUMsY0FBYyxFQUFFLElBQUksRUFBRSxDQUFDO1FBQ3ZELE1BQU0sQ0FBQyxNQUFNLENBQUMsU0FBUyxFQUFFO1lBQ3JCLE9BQU8sRUFBRSxNQUFNO1lBQ2YsWUFBWSxFQUFFLElBQUksQ0FBQyxTQUFTLENBQUMsV0FBVyxDQUFDO1lBQ3pDLFlBQVksRUFBRSx3QkFBZ0IsQ0FBRSxTQUFxQixDQUFDLFlBQVksQ0FBQyxJQUFJLEVBQUU7U0FDNUUsQ0FBQyxDQUFDO0lBQ1AsQ0FBQztJQUNELFdBQVcsQ0FBQyxRQUFRLENBQUM7UUFDakIsU0FBUztRQUNULFlBQVk7UUFDWixPQUFPLEVBQUUsU0FBUztLQUNyQixDQUFDLENBQUM7QUFDUCxDQUFDIn0=